import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-books-table',
  templateUrl: './books-table.component.html',
  styleUrls: ['./books-table.component.scss']
})
export class BooksTableComponent implements OnInit {

  @Input('table-data') tableData: any[] = [];
  @Input('page') page: number = 1;
  @Output('action') action = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  onDeleteClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: false,
      isDelete: true,
      isView: false,
      data: data,
    });
  }

  onEditClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: true,
      isDelete: false,
      isView: false,
      data: data,
    });
  }

  onViewClick(data: any) {
    this.action.emit({
      isAddSloka: false,
      isEdit: false,
      isDelete: false,
      isView: true,
      data: data,
    });
  }

}
